// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37e4fefd","838":"6f5733b0"}[chunkId] + ".chunk.js";
};